export const SCROLL_BOTTOM_THRESHOLD = 80;

/** When true, streaming updates may keep the chat pinned to the bottom. */
export const chatAutoScrollEnabledRef = { current: true };

function canScrollVertically(element: HTMLElement): boolean {
  const overflowY = window.getComputedStyle(element).overflowY;
  if (overflowY !== 'auto' && overflowY !== 'scroll') return false;
  return element.scrollHeight > element.clientHeight + 1;
}

/**
 * Prefer `#scroll-container` when it is the overflowing pane (conversation log).
 * Otherwise use the nearest overflowing ancestor so advisor-page sticky tabs
 * can share a single page scroller without breaking follow-bottom.
 */
export function getScrollContainer(): HTMLElement | null {
  const inner = document.getElementById('scroll-container');
  if (!inner) return null;
  if (canScrollVertically(inner)) return inner;

  let current: HTMLElement | null = inner.parentElement;
  while (current) {
    if (canScrollVertically(current)) return current;
    current = current.parentElement;
  }
  return inner;
}

export function getDistanceFromBottom(container: HTMLElement): number {
  return container.scrollHeight - container.scrollTop - container.clientHeight;
}

export function isNearBottom(
  container: HTMLElement,
  threshold = SCROLL_BOTTOM_THRESHOLD
): boolean {
  return getDistanceFromBottom(container) <= threshold;
}

export function updateChatAutoScrollState(event?: Event): void {
  const scrollContainer = getScrollContainer();
  if (!scrollContainer) return;
  if (event && event.target !== scrollContainer) return;
  chatAutoScrollEnabledRef.current = isNearBottom(scrollContainer);
}

export function scrollChatToBottom(
  behavior: ScrollBehavior = 'smooth',
  force = false
): void {
  const scrollContainer = getScrollContainer();
  if (!scrollContainer) return;
  if (!force && !chatAutoScrollEnabledRef.current) return;
  scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior });
}

export function enableChatAutoScroll(): void {
  chatAutoScrollEnabledRef.current = true;
}
